import React, { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Pages/Header';
import Sidebar from '../Pages/Sidebar';
import { PAY_URL } from '../../../BaseURL';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Pagination, Search } from '../Table';
import CopyRight from '../Pages/CopyRight';
import Loader from '../Pages/Loader';
import ProcessLoader from '../Components/ProcessLoader';
import DropDonwlLimit from '../Components/DropDonwlLimit';
import TooltipWrapper from '../Components/TooltipWrapper';
import { DownloadSample } from '../Components/DownloadSample';

const YearlySalReport = () => {
    const navigate = useNavigate();
    const [entity, setEntity] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [disable, setDisable] = useState(true);
    const [loader, setLoader] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState({ _id: "", full_name: "" });
    const [employeeData, setEmployeeData] = useState([]);

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        }
        if (disable || (selectedEmployee?._id)) {
            getReport();
            setEntity([]);
        }
        getEmployee();
    }, [disable, navigate, selectedEmployee]);

    const getEmployee = () => {
        const myurl = `${PAY_URL}/user/get-all-employee`;
        axios({
            method: "get",
            url: myurl,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then(async (response) => {
            // console.log(response.data, '$$$')
            if (response?.data?.success) {
                const data = response?.data?.data
                const filterData = data.filter((e) => e.firm_id === localStorage.getItem('PAY_USER_FIRM_ID'));
                setEmployeeData(filterData);
            } else {
                toast.error("Something went wrong");
            }
        }).catch((error) => {
            toast.error("Something went wrong");
            console?.log("Errors", error);
        });
    }

    const commentsData = useMemo(() => {
        let computedComments = entity;

        entity?.forEach((record) => {
            if (Array.isArray(record?.employee_details)) {
                computedComments = [...record.employee_details];
            }
        });

        computedComments = computedComments.filter(item => item && Object.keys(item).length > 0);

        if (search) {
            computedComments = computedComments.filter(
                (report) =>
                    report?.employeeName?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    report?.employee_id?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    report?.card_no?.toLowerCase()?.includes(search?.toLowerCase())
            );
        }

        setTotalItems(computedComments.length);

        return computedComments.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );

    }, [currentPage, search, limit, entity]);

    const getReport = () => {
        const formData = new URLSearchParams();
        formData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
        formData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
        formData.append('employee', selectedEmployee?._id);

        const myurl = `${PAY_URL}/user/list-yearly-salary-report`;

        axios({
            method: "POST",
            url: myurl,
            data: formData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then(async (response) => {
            if (response?.data?.success === true) {
                const data = response?.data?.data
                setEntity(data);
                setDisable(false);
            } else {
                toast.error(response?.data?.message);
                setDisable(false);
            }
        }).catch((error) => {
            toast.error(error.response?.data?.message || "Something went wrong");
            setDisable(false);
        });
    }

    const handleEmployeeChange = (e) => {
        const selectedId = e.target.value;
        const selectedEmp = employeeData.find(emp => emp._id === selectedId);

        setSelectedEmployee({
            _id: selectedEmp?._id || "",
            full_name: selectedEmp?.full_name || "",
        });
    };

    const downloadReport = () => {
        setLoader(true);
        const myurl = `${PAY_URL}/user/yearly-salary-report-download`;
        const bodyFormData = new URLSearchParams();
        bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
        bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
        bodyFormData.append('employee', selectedEmployee?._id);
        bodyFormData.append("print_date", true)
        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then((response) => {
            if (response.data.success === true) {
                const fileUrl = response.data.data.file;
                toast.success(response?.data?.message);
                window.open(fileUrl, '_blank');
            } else {
                toast.error(response?.data?.message);
            }
        }).catch((error) => {
            console.log(error, '!!');
            toast.error(error?.response?.data.message);
        }).finally(() => {
            setLoader(false);
        })
    }

    const handleRefresh = () => {
        setDisable(true);
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title user-title">Yearly Salary Report Management</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/user/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Yearly Salary Report Management</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row filter-row justify-content-between align-items-center">
                        <div className='col-md-4 col-lg-4 col-sm-12'>
                            <select
                                className="form-select form-control"
                                value={selectedEmployee._id}
                                onChange={handleEmployeeChange}
                                aria-label="Default select example"
                            >
                                <option value=''>Select Employee</option>
                                {employeeData.map(e => (
                                    <option key={e._id} value={e._id}>{e.full_name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-sm-12 col-md-4">
                            <div className="row justify-content-end">
                                <div className="col-md-12 mb-2">
                                    {/* <label htmlFor="month" className="form-label">&nbsp;</label> */}
                                    <div className="justify-content-end d-flex align-center flex-wrap gap-2">
                                        <div className="seletePage d-flex gap-2 align-items-center ">
                                            {/* <p className="mb-0">Rows per page:</p> */}
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <DropDonwlLimit limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                <TooltipWrapper tooltipText="Refresh">
                                                    <div className="refreshPage">
                                                        <button className="btn btn-refresh" type='button' onClick={handleRefresh}>
                                                            <i className="fa-solid fa-arrows-rotate"></i>
                                                        </button>
                                                    </div>
                                                </TooltipWrapper>
                                            </div>
                                            <TooltipWrapper tooltipText="Download Report">
                                                <div className="refreshPage">
                                                    <button className="btn btn-refresh" type='button' onClick={downloadReport}>
                                                        {loader ? <ProcessLoader /> : <i className="fa-solid fa-download"></i>}
                                                    </button>
                                                </div>
                                            </TooltipWrapper>
                                        </div>
                                        <div className="tableSearch">
                                            <form action="">
                                                <Search
                                                    onSearch={(value) => {
                                                        setSearch(value);
                                                        setCurrentPage(1);
                                                    }} />
                                                <span className="search">
                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                </span>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {disable === false ? (
                        <div className="card p-3 ">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive">
                                        <table className="table table-striped custom-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Sr.</th>
                                                    <th>Employee Name</th>
                                                    <th>Employee Id</th>
                                                    <th>Designation</th>
                                                    <th>Department</th>
                                                    <th>Gross Salary</th>
                                                    <th>PF Amm.</th>
                                                    <th>PT Amm.</th>
                                                    <th>Mess</th>
                                                    <th>Loan</th>
                                                    <th>Advance</th>
                                                    <th>Penalty</th>
                                                    <th>Other</th>
                                                    <th>Total Deduction</th>
                                                    <th>Net Salary</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {commentsData?.map((elem, i) => (
                                                    <tr key={elem?._id}>
                                                        <td>{(currentPage - 1) * limit + i + 1}</td>
                                                        <td>{elem?.employeeName}</td>
                                                        <td>{elem?.employeeId}</td>
                                                        <td>{elem?.designation || "-"}</td>
                                                        <td>{elem?.department}</td>
                                                        <td>{elem?.mt_gross_wages ? parseFloat((elem.mt_gross_wages).toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_pfAmount ? parseFloat(elem.mt_pfAmount.toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_ptAmount ? parseFloat(elem.mt_ptAmount.toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_Mess ? parseFloat(elem.mt_Mess.toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_Loan ? parseFloat(elem.mt_Loan.toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_Advanced ? parseFloat(elem.mt_Advanced.toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_Penalty ? parseFloat(elem.mt_Penalty.toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_Other ? parseFloat(elem.mt_Other.toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_total_deduction ? parseFloat(elem.mt_total_deduction.toFixed(2)) : "0.00"}</td>
                                                        <td>{elem?.mt_net_salary ? parseFloat(elem.mt_net_salary.toFixed(2)) : "0.00"}</td>
                                                    </tr>
                                                ))}

                                                <tr>
                                                    <td colSpan={5} className='text-center fw-bold'>Total</td>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_gross_wages || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_pfAmount || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_ptAmount || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_Mess || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_Loan || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_Advanced || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_Penalty || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_Other || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_total_deduction || 0), 0).toFixed(2))}
                                                    </th>
                                                    <th>
                                                        {parseFloat(commentsData?.reduce((total, elem) => total + (elem?.mt_net_salary || 0), 0).toFixed(2))}
                                                    </th>
                                                </tr>
                                                {commentsData?.length === 0 ? (
                                                    <tr>
                                                        <td colspan="999">
                                                            <div className="no-table-data">
                                                                No Data Found!
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row align-center mt-3 user-account">
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                            <div className="dataTables_paginate paging_simple_numbers"
                                                id="DataTables_Table_0_paginate">
                                                <Pagination
                                                    total={totalItems}
                                                    itemsPerPage={limit}
                                                    currentPage={currentPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : <Loader />}
                    <CopyRight />
                </div>
            </div>
        </div>
    )
}

export default YearlySalReport